import React from 'react';
import { ExternalLink } from 'lucide-react';
import data from '../../data/pathway15states.json';
import { SourceButton } from './SourceDrawer';

const ce = data.compact_evidence;
const SRC = Object.fromEntries(ce.sources.map((s) => [s.id, s]));

const SrcList = ({ ids }) => (
  <ul className="space-y-2">{ids.map((id) => SRC[id]).filter(Boolean).map((s) => (
    <li key={s.id} className="rounded-2xl border border-gray-200 bg-white p-3 text-xs space-y-1" data-testid={`p15-source-${s.id}`}>
      <p className="font-bold text-gray-900">{s.title}</p><p className="text-gray-600">{s.publisher}{s.publication_date ? ` · ${s.publication_date}` : ''}</p>
      {s.date_basis && <p className="text-gray-600">{s.date_basis}</p>}{s.scope && <p>{s.scope}</p>}{s.limitation && <p className="text-gray-700">{s.limitation}</p>}
      {s.url && <a href={s.url} target="_blank" rel="noopener noreferrer" className="text-teal-700 underline inline-flex items-center gap-1">Open source <ExternalLink size={11} /></a>}
    </li>))}</ul>
);

export const EvidenceCompact = ({ openDrawer }) => (
  <section className="space-y-3 min-w-0" data-testid="p15-evidence" aria-labelledby="p15-evidence-heading">
    <div><h2 id="p15-evidence-heading" className="text-xl sm:text-2xl font-extrabold text-gray-900">{ce.heading}</h2><p className="text-sm text-gray-600 mt-1">{ce.intro}</p></div>
    <div className="grid grid-cols-1 min-[701px]:grid-cols-2 gap-3 items-start">
      {ce.cards.map((c) => (
        <article key={c.id} className="rounded-2xl border border-gray-200 bg-white p-4 flex flex-col gap-2 min-w-0" data-testid={`p15-evidence-${c.id}`}>
          <span className="self-start inline-flex rounded-full border border-gray-200 bg-gray-100 text-gray-700 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest break-words">{c.label}</span>
          <h3 className="text-sm font-extrabold text-gray-900 leading-tight break-words">{c.title}</h3>
          <p className="text-xs text-gray-700">{c.text}</p>
          <div className="mt-auto flex flex-wrap items-center gap-3 pt-1">
            {SRC[c.source_ids[0]]?.url && <a href={SRC[c.source_ids[0]].url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-bold text-gray-900 underline underline-offset-4" data-testid={`p15-evidence-${c.id}-link`}>Open source <ExternalLink size={11} /></a>}
            <SourceButton label="Source & meaning" testId={`p15-evidence-${c.id}-drawer`} onClick={() => openDrawer({ title: c.title, description: c.label, sourceIds: [], node: <SrcList ids={c.source_ids} /> })} />
          </div>
        </article>))}
    </div>
    <p className="text-xs text-gray-500">Evidence checked {ce.checked_on} (review date, not a new observation).</p>
  </section>
);
